export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("crm-cards-sdk/lang/en.lyaml"));
vm(require("crm-component-utils/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
at({ "en": { "crmStageTracker": { "error": { "objectTypeWithoutPipeline": "This object type doesn't have a pipeline to render." }, "input": { "readonly": "This property can\u2019t be edited." }, "progressBar": { "closedStage": "Closed stage" }, "timeInStage": { "duration": "for {{ timeInStageDuration }}", "empty": "for a few seconds" } } } });
};